/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Dashboard_Current_Form_SubtitleInputs */

const en_ui_dashboard_current_form_subtitle = /** @type {(inputs: Ui_Dashboard_Current_Form_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your training readiness`)
};

const de_ui_dashboard_current_form_subtitle = /** @type {(inputs: Ui_Dashboard_Current_Form_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie bereit du bist`)
};

/**
* | output |
* | --- |
* | "Your training readiness" |
*
* @param {Ui_Dashboard_Current_Form_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_dashboard_current_form_subtitle = /** @type {((inputs?: Ui_Dashboard_Current_Form_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Dashboard_Current_Form_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_dashboard_current_form_subtitle(inputs)
	return de_ui_dashboard_current_form_subtitle(inputs)
});